export const formatGuid = (value = '') => {
  return value.toLowerCase().replace(/_/g, '-')
}
